/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

import { getSearchParams } from '@amazon/vinyl-util'

/**
 * App-wide reader for a single URL query parameter, built on vinyl-util's
 * memoized {@link getSearchParams}. Use this instead of a local
 * `URLSearchParams` parse so every call site shares one parsed/cached
 * `location.search`.
 */
export function queryParam(name: string): string | null {
    return getSearchParams().get(name)
}

/**
 * Sets or clears a query parameter and navigates (full reload) to the
 * resulting URL.
 */
export function updateQueryParam(key: string, value: string | null): void {
    const url = new URL(window.location.href)

    if (value === null) {
        url.searchParams.delete(key)
    } else {
        url.searchParams.set(key, value)
    }
    window.location.href = url.toString()
}
